import React from 'react';

const PrometheusIcon = () => {
  return (
    React.createElement('svg', {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18"   ,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",}
    
      , React.createElement('path', {
        d: "M8.95164 0.764648C4.37635 0.764648 0.666992 4.47357 0.666992 9.04901C0.666992 13.6243 4.37635 17.3335 8.95164 17.3335C13.5269 17.3335 17.2361 13.6243 17.2361 9.04901C17.2361 4.47357 13.5268 0.764648 8.95164 0.764648ZM8.95164 16.2698C7.64989 16.2698 6.59448 15.4002 6.59448 14.3278H11.3088C11.3088 15.4 10.2534 16.2698 8.95164 16.2698ZM12.8449 13.6847H5.05793V12.2727H12.8451L12.8449 13.6847ZM12.817 11.5459H5.08015C5.05442 11.5163 5.0281 11.487 5.00325 11.4569C4.20617 10.4891 4.01845 9.9838 3.83614 9.46889C3.83307 9.45193 4.80267 9.66699 5.49024 9.82167C5.49024 9.82167 5.84404 9.90354 6.36129 9.99784C5.86465 9.41567 5.56977 8.67561 5.56977 7.91918C5.56977 6.25851 6.84345 4.80734 6.38395 3.63439C6.83117 3.67079 7.30954 4.57825 7.34185 5.99711C7.81728 5.34009 8.01626 4.14023 8.01626 3.40456C8.01626 2.64287 8.51816 1.75807 9.02021 1.72781C8.57269 2.46538 9.13614 3.09769 9.63702 4.66626C9.82489 5.25544 9.80091 6.24696 9.94594 6.87576C9.99404 5.56977 10.2186 3.66421 11.0471 3.00632C10.6816 3.83482 11.1012 4.87152 11.3882 5.36991C11.8512 6.17401 12.1319 6.78322 12.1319 7.93541C12.1319 8.70792 11.8467 9.43526 11.3655 10.0038C11.9126 9.9012 12.2904 9.80865 12.2904 9.80865L14.067 9.46202C14.0671 9.46187 13.809 10.5236 12.817 11.5459Z"                                                                                                                         ,
        fill: "#E6522C",}
      )
    )
  );
};

export default PrometheusIcon;
